import React from 'react';

import { useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';

import { Link } from 'react-router-dom';

import { Breadcrumb } from '../../../components/Breadcrumb';
import { Button } from '../../../components/Button';
import { Footer } from '../../../components/Footer';
import { Header } from '../../../components/Header';
import { Tag } from '../../../components/Tag';
import './style.css';

import DateUtils from '../../../utils/DateUtils';

import PreviewBox from '../../../components/PreviewBox/PreviewBox';

export const StandardSingleMaterialView = ({
    portalResource,
    footerPortalResources,
	footerVideoFAQItems,
    serverSettings,
}) => {
    const navigate = useNavigate();

    const [selectedSection, setSelectedSection] = useState(0);

    useEffect(() => {
        // The [] is for specifying dependencies, and for componentDidMount lifecycle equivalent
        // we need to specify no dependencies.
        // See https://stackoverflow.com/questions/53945763/componentdidmount-equivalent-on-a-react-function-hooks-component
    }, []);

    if (null == portalResource || null == footerPortalResources || null == footerVideoFAQItems) {
        return null;
    }

    return (
        <div className="single-material">
            <Header
                className="design-component-instance-node-5"
                style="desktop"
                shareFeedbackEmailAddress={
                    serverSettings.shareFeedbackEmailAddress
                }
                logoDimensions={{
                    height: 64 * 1.8 + 'px',
                    width: 104 * 1.8 + 'px',
                }}
            />

            {buildIntroductoryInfoPart(portalResource)}

            {null == portalResource.sections ||
            0 === portalResource.sections.length ? null : (
                <div className="tab-single-material-wrapper">
                    <div className="tab-single-material">
                        <div className="div-17">
                            {1 > portalResource.sections.length ? null : (
                                <Button
                                    className="button-7"
                                    status={
                                        selectedSection === 0
                                            ? 'active'
                                            : 'default'
                                    }
                                    style="secondary"
                                    textLink={
                                        portalResource.sections[0].heading
                                    }
                                    onClick={() => {
                                        setSelectedSection(0);
                                    }}
                                />
                            )}

                            {2 > portalResource.sections.length ? null : (
                                <Button
                                    className="button-7"
                                    status={
                                        selectedSection === 1
                                            ? 'active'
                                            : 'default'
                                    }
                                    style="secondary"
                                    textLink={
                                        portalResource.sections[1].heading
                                    }
                                    onClick={() => {
                                        setSelectedSection(1);
                                    }}
                                />
                            )}

                            {3 > portalResource.sections.length ? null : (
                                <Button
                                    className="button-7"
                                    status={
                                        selectedSection === 2
                                            ? 'active'
                                            : 'default'
                                    }
                                    style="secondary"
                                    textLink={
                                        portalResource.sections[2].heading
                                    }
                                    onClick={() => {
                                        setSelectedSection(2);
                                    }}
                                />
                            )}
                        </div>

                        <div className="tab-content">
                            <div className="tab">
                                <div className="div-18">
                                    {/*<div className="heading-4">{portalResource.sections[selectedSection].heading}</div>*/}
                                    <p
                                        className="summary"
                                        dangerouslySetInnerHTML={{
                                            __html: removeMeyerResetCSSListSettingsFromHtmlString(
                                                portalResource.sections[
                                                    selectedSection
                                                ].text,
                                            ),
                                        }}
                                    ></p>
                                </div>

                                {/*<div className="heading-5">Gamification beim Lernen</div>*/}

                                <div className="accordion-2">
                                    <div className="div-18">
                                        {buildSubSections(
                                            portalResource.sections[
                                                selectedSection
                                            ].subSections,
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <div className="content-wrapper-2">
                <div className="content-14">
                    <p className="subtitle-5">Was interessiert Sie heute?</p>
                    <div className="cards-swiper">
                        {buildFooterGalleryItems(footerPortalResources, footerVideoFAQItems)}
                    </div>
                    <Button
                        className="design-component-instance-node-6"
                        status="default"
                        style="default"
                        textLink="Alle Materialien"
                        onClick={() => {
                            navigate('/directory');
                        }}
                    />
                </div>
            </div>

            <Footer
                className="design-component-instance-node-5"
                logosPartnersGroupLogoPartnerBundesministerium="/img/BMBFSFJ_gefoerdert_vom_deutsch_Web_c.svg"
                property1="desktop"
            />
        </div>
    );

	function buildFooterGalleryItems(footerPortalResources, footerVideoFAQItems){
		let footerGalleryItems = [].concat(footerPortalResources);
				
		for(let i = 0; i < footerVideoFAQItems.length; i++){
			let faqItem = footerVideoFAQItems[i];
			
			let faqItemAsPortalResource = {
				id: faqItem.id,
				title: faqItem.title,
				resourceType: {name: "FAQ"},
				titleMediaType: "TITLE_MEDIA_TYPE_VIDEO",
				titleVideo: faqItem.video,
				isVideoFAQItem: true,
				sections: [{ text: faqItem.htmlContent }],
				dateCreation: faqItem.dateUpDate
			}
			
			footerGalleryItems.push(faqItemAsPortalResource);
		}
		
		footerGalleryItems.sort((a, b) => b.dateCreation - a.dateCreation);
			
		return footerGalleryItems.slice(0,4).map((item, i)=>{
			return <PreviewBox
                element={item}
                i={i}
                shouldCenter={true}
                shouldMaxHeight={true}
                showDate={
                    serverSettings.isFrontPageResourceCreationDateVisible
                }
            />
		});
	}

    // The codebase we received after export uses some kind of CSS reseting tool called meyer-reset
    // https://cdnjs.cloudflare.com/ajax/libs/meyer-reset/2.0/reset.min.css.
    // My understanding is limited, but the point of this tool is I think to strip all style from elements,
    // so that web designers can start fresh. A problem though is that I can't find a way to override its settings
    // for lists. I tried setting lists-style:revert on divs or <p> tags surrounding the list, but there is no effect.
    // The meyer-reset setting is always applied. The only thing that works is when the styling is specified directly
    // on the element. So what this function does is take the rawHtml a content authors via TinyMCE Editor, and search
    // for lists (with tag <ol> or <ul>) and rewrite them to include the styling necessary to remove the effect of
    // the meyer-reset... There has to be a better way ...
    function removeMeyerResetCSSListSettingsFromHtmlString(text) {
        if (null == text) {
            return null;
        } else {
            return text
                .replace('<ol>', '<ol style="list-style: revert;">')
                .replace('<ul>', '<ul style="list-style: revert;">');
        }
    }

    function buildRatingsStarDisplay(aggregateUserRating) {
        let stars = [];

        // Calc number of full stars
        let numFullStars = Math.floor(aggregateUserRating);

        for (let i = 0; i < numFullStars; i++) {
            stars.push(
                <img
                    key={'userRating-full-star-' + i}
                    className="img-4"
                    alt="Star fill"
                    src="/img/star-fill-10.svg"
                />,
            );
        }

        // Then do the half stars
        let leftOver = aggregateUserRating - numFullStars;

        if (0.5 <= leftOver) {
            stars.push(
                <img
                    key={'userRating-half-star'}
                    className="img-4"
                    alt="Star half"
                    src="/img/star-half-4.svg"
                />,
            );
        }

        // Finally pad with unfilled stars if needed (assumes we want to show 5 stars)
        let numEmptyStarsNeeded = 5 - stars.length;
        for (let i = 0; i < numEmptyStarsNeeded; i++) {
            stars.push(
                <img
                    key={'userRating-empty-star-' + i}
                    className="img-4"
                    alt="Star"
                    src="/img/star-4.svg"
                />,
            );
        }

        return stars;
    }

    function buildScientificQualityBarsDisplay(
        scientificQualityPdfUrl,
        aggregateScientificQualityRating,
    ) {
        /*
	let filename = "scientific_bars_NUMBER.png";
	
	if(1 > aggregateScientificQualityRating ){
		filename = filename.replace("NUMBER", "0")
	}
	else if(2 > aggregateScientificQualityRating ){
		filename = filename.replace("NUMBER", "1")
	}
	else if(3 > aggregateScientificQualityRating ){
		filename = filename.replace("NUMBER", "2")
	}
	else {
		filename = filename.replace("NUMBER", "3")
	}
	*/

        let filename = 'scientific_bars_3.png';

        return (
            <Link to={scientificQualityPdfUrl} target="_blank">
                <div style={{ display: 'line-flex' }}>
                    <img
                        className="icon-2"
                        alt="Icon"
                        src={'/img/' + filename}
                    />

                    {/*<span style={{marginLeft: "5px"}}>
				{"(" + Number(aggregateScientificQualityRating).toFixed(1)  + ")" }
			</span>*/}
                </div>
            </Link>
        );
    }

    function buildBreadCrumbTitle(shortTitle, fullTitle) {
        if (null != shortTitle) {
            return shortTitle;
        } else {
            return fullTitle;
        }
    }

    function buildIntroductoryInfoPart(portalResource) {
        return (
            <div className="content-wrapper-2">
                <div className="content-11">
                    <div className="frame-24">
                        <div className="frame-25">
                            <div className="frame-26">
                                <Breadcrumb
                                    breadcrumb="two-level"
                                    className="design-component-instance-node-6"
                                    breadcrumbText={buildBreadCrumbTitle(
                                        portalResource.shortTitle,
                                        portalResource.title,
                                    )}
                                />
                                <div className="h">{portalResource.title}</div>
                                <div className="h-2">
                                    {
                                        null != portalResource.subTitle
                                            ? portalResource.subTitle
                                            : null /*Gamification beim Lernen*/
                                    }
                                </div>
                            </div>

                            <div className="div-17">
                                <Tag
                                    className="design-component-instance-node-6"
                                    size="default"
                                    stateProp="default"
                                    style="default"
                                    text={portalResource.mediaUsageGoal.goal}
                                    isClickable={false}
                                />

                                {null == portalResource.subjectMatterCategories
                                    ? null
                                    : portalResource.subjectMatterCategories.map(
                                          (cat, i) => {
                                              return (
                                                  <Tag
                                                      className="design-component-instance-node-6"
                                                      size="default"
                                                      stateProp="default"
                                                      style="default"
                                                      text={cat.category}
                                                      isClickable={false}
                                                  />
                                              );
                                          },
                                      )}

                                {null == portalResource.schoolTypes
                                    ? null
                                    : portalResource.schoolTypes.map(
                                          (schoolType, i) => {
                                              return (
                                                  <Tag
                                                      className="design-component-instance-node-6"
                                                      size="default"
                                                      stateProp="default"
                                                      style="default"
                                                      text={schoolType.name}
                                                      isClickable={false}
                                                  />
                                              );
                                          },
                                      )}

                                {
                                    // leaving this here to document that tags can also appear as "featured"
                                    /*}<Tag
                  className="design-component-instance-node-6"
                  size="default"
                  stateProp="default"
                  style="featured"
                  text="Aufbereitung"
                />*/
                                }
                            </div>

                            {/* Indicators section */}

                            <div className="frame-27">
                                {!portalResource.isScientificRatingVisible ? null : (
                                    <div className="icon-box">
                                        {buildScientificQualityBarsDisplay(
                                            portalResource.scientificQualityPdfUrl,
                                            portalResource.aggregateScientificQualityRating,
                                        )}
                                        <div className="heading-3">
                                            Wissenschaftliche Qualität
                                        </div>
                                    </div>
                                )}

                                <div className="icon-box">
                                    <img
                                        className="icon-2"
                                        alt="Icon"
                                        src="/img/icon-2.svg"
                                    />
                                    <div className="heading-3">
                                        ca.{' '}
                                        {DateUtils.formatReadingTimeDuration(
                                            portalResource.estimatedReadingTimeInMinutes,
                                        )}
                                    </div>
                                </div>

                                {!portalResource.isUserRatingVisible ? null : (
                                    <div className="icon-box">
                                        <div className="icon-3">
                                            <div className="frame-28">
                                                {buildRatingsStarDisplay(
                                                    portalResource.aggregateUserRating,
                                                )}
                                            </div>
                                        </div>
                                        <div className="heading-3">
                                            User rating
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* Authoring section */}

                            <div className="frame-27">
                                {null == portalResource.authors
                                    ? null
                                    : portalResource.authors.map(
                                          (author, i) => {
                                              return (
                                                  <div
                                                      key={'author-' + i}
                                                      className="member-avatar"
                                                  >
                                                      <div className="avatar">
                                                          {buildAuthorPicture(
                                                              author,
                                                          )}
                                                      </div>

                                                      <div className="text-and-supporting-3">
                                                          <label
                                                              className="username"
                                                              htmlFor="input-2"
                                                          >
                                                              {author.firstName +
                                                                  ' ' +
                                                                  author.lastName}
                                                          </label>
                                                          {null ==
                                                          author.email ? null : (
                                                              <input
                                                                  className="email-2"
                                                                  id="input-2"
                                                                  placeholder={
                                                                      null ==
                                                                      author.email
                                                                          ? null
                                                                          : author.email
                                                                  }
                                                                  type="text"
                                                              />
                                                          )}
                                                      </div>
                                                  </div>
                                              );
                                          },
                                      )}
                            </div>
                        </div>

                        <div className="featured-image">
                            <div
                                className="frame-29"
                                style={{
                                    backgroundImage:
                                        'url(' +
                                        portalResource.titleImage +
                                        ')',
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    function buildAuthorPicture(author) {
        if (null == author.authorPhoto) {
            return <div className="profile-img" />;
        } else {
            return (
                <div
                    className="profile-img"
                    style={{
                        backgroundImage: "url('" + author.authorPhoto + "')",
                    }}
                />
            );
        }
    }

    function buildSubSections(subSections) {
        if (null == subSections) {
            return null;
        }

        return subSections.map((subSection, i) => {
            return (
                <div key={'subSection-' + i} className="content-12">
                    <div className="heading-6">{subSection.heading}</div>

                    <p
                        className="content-13"
                        dangerouslySetInnerHTML={{
                            __html: removeMeyerResetCSSListSettingsFromHtmlString(
                                subSection.text,
                            ),
                        }}
                    ></p>
                </div>
            );
        });
    }
};
